import {Highlight} from "../Highlight/Highlight";
import {useConfigContext} from "../../../ConfigProvider.js";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export function Product({hit, postFixLink}) {
    const {algoliaConfig:{customizedUrl}} = useConfigContext();

  const siteCode =
    typeof document !== "undefined"
      ? (document.body?.dataset?.site_code || "").toLowerCase()
      : "";

  let hideFlag;
  const ad = hit?.additional_data;
  if (ad) {
    if (typeof ad === "string") {
      try { hideFlag = JSON.parse(ad)["hide-in-catalog"]; } catch {}
    } else if (typeof ad === "object") {
      hideFlag = ad["hide-in-catalog"] ?? ad.hide_in_catalog ?? ad.hideInCatalog;
    }
  }

  const shouldHide =
    siteCode === "catalog" &&
    (hideFlag === "1" || hideFlag === 1 || hideFlag === true || hideFlag === "true");

  if (shouldHide) return null;

  const itemLink = "/" + customizedUrl + hit?.itemLink;

  return (
    <li
      id={`item_${hit.itemId}`}
      key={`product-${hit.objectID}`}
      className="ais-autocomplete-item js-updateAlgoliaItemboxElement"
      data-itemno={hit.itemNo}
      data-item-id={hit.itemId}
      role="listitem"
    >
      <a
        href={itemLink + "?search_query=" + postFixLink}
        title={hit.description}
        data-gtm-item={hit.itemId}
        className="gtm-product-click"
      >
        <span>
          <Highlight hit={hit} attribute="description" />
        </span>
      </a>
    </li>
  );
}
